module.exports = __webpack_public_path__ + "img/user_guide_3.f93e2f86.png";